export const currentPage = window.location.search ? parseInt(window.location.search.split('=')[1], 10) : 1;

export const addPaginationButtons = (total, numberInPage) => {
	if (total > numberInPage) {
		for (let i = 1; i < (total / numberInPage) + 1; i += 1) {
			const template = document.querySelector('._template-block > .page').cloneNode(true);
			template.href += `?page=${i}`;
			template.innerHTML = i;
			template.className += `${(i === currentPage) ? ' -active' : ''}`;
			document.querySelector('.tab-list').appendChild(template);
		}
	}
};

export default 'this is pagination';



// WEBPACK FOOTER //
// ./src/js/pagination.js